export default function flipVertically(position, context) {
  var anchorAttachmentY = context.anchorAttachmentY,
      anchorHeight = context.anchorHeight,
      anchorOffsetY = context.anchorOffsetY,
      isWithinWindow = context.isWithinWindow,
      targetAttachmentY = context.targetAttachmentY,
      targetHeight = context.targetHeight,
      targetOffsetY = context.targetOffsetY,
      targetMarginTop = context.targetMarginTop,
      targetMarginBottom = context.targetMarginBottom,
      withinHeight = context.withinHeight,
      withinScrollTop = context.withinScrollTop,
      withinTop = context.withinTop;
  var withinOffset = withinTop + withinScrollTop;
  var offsetTop = isWithinWindow ? withinScrollTop : withinTop;
  var collisionHeight = targetHeight + targetMarginTop + targetMarginBottom;
  var collisionPositionTop = position.top - targetMarginTop;
  var overTop = collisionPositionTop - offsetTop;
  var overBottom = collisionPositionTop + collisionHeight - withinHeight - offsetTop;
  var offset = -2 * (anchorOffsetY + targetOffsetY);
  var targetOffset;
  var anchorOffset;

  if (targetAttachmentY === 'top') {
    targetOffset = -targetHeight;
  } else if (targetAttachmentY === 'bottom') {
    targetOffset = targetHeight;
  } else {
    targetOffset = 0;
  }

  if (anchorAttachmentY === 'top') {
    anchorOffset = anchorHeight;
  } else if (anchorAttachmentY === 'bottom') {
    anchorOffset = -anchorHeight;
  } else {
    anchorOffset = 0;
  }

  var newOverBottom;
  var newOverTop;
  var newPositionTop = position.top;

  if (overTop < 0) {
    newOverBottom = position.top + targetOffset + anchorOffset + offset + collisionHeight - withinHeight - withinOffset;

    if (newOverBottom < 0 || newOverBottom < Math.abs(overTop)) {
      newPositionTop += targetOffset + anchorOffset + offset;
    }
  } else if (overBottom > 0) {
    newOverTop = position.top - targetMarginTop + targetOffset + anchorOffset + offset - offsetTop;

    if (newOverTop > 0 || Math.abs(newOverTop) < overBottom) {
      newPositionTop += targetOffset + anchorOffset + offset;
    }
  }

  return {
    left: position.left,
    top: newPositionTop
  };
}